"use client";

import { useFormControl } from "../__chunks/KKXTCJYN.js";
import "../__chunks/PQKUBRVU.js";
import "../__chunks/SZHY72KI.js";
import "../__chunks/G4PVPWEW.js";
import { createElement, createHook, forwardRef, memo } from "../__chunks/7FZLUSKW.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/form/form-field.tsx
var TagName = "input";
var useFormField = createHook(function useFormField2(props) {
  return useFormControl(props);
});
var FormField = memo(forwardRef(function FormField2(props) {
  var htmlProps = useFormField(props);
  return createElement(TagName, htmlProps);
}));
export { FormField, useFormField };